import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function NftHide({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M21 13V17C21 19.2 19.2 21 17 21H7M7 21C4.79 21 3 19.2 3 17V7C3 4.79 4.79 3 7 3H11M7 21L13.29 14.7C14.23 13.75 15.75 13.75 16.69 14.7L20.62 18.63M3 13L4.29 11.7C5.23 10.75 6.75 10.75 7.69 11.69L11.98 15.98M18.3788 5.90099C18.4288 5.95099 18.4288 6.04099 18.3788 6.10099C18.3188 6.15099 18.2288 6.15099 18.1688 6.10099C18.1088 6.04099 18.1088 5.95099 18.1688 5.89099C18.2188 5.83099 18.3088 5.83099 18.3688 5.89099M14.7598 6.68999C14.4798 6.26999 14.4798 5.71999 14.7598 5.30999C15.5998 4.01999 16.9398 2.98999 18.2728 2.98999C19.6028 2.98999 20.9328 4.00999 21.7828 5.29999C22.0528 5.70999 22.0528 6.25999 21.7828 6.67999C20.9328 7.96199 19.5928 8.98999 18.2628 8.98999C16.9228 8.98999 15.5928 7.95999 14.7498 6.67999L14.7598 6.68999Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default NftHide;